import { gql, type TypedDocumentNode } from '@apollo/client';

import { COMPETITION_COLORS } from '@sorare/core/src/lib/colors';
import { isTypes } from '@sorare/core/src/lib/gql';
import type { HexColor } from '@sorare/core/src/style/types';

import type { getTaskCompetitionColor_taskInterface } from './__generated__/index.graphql.ts';

export const getTaskCompetitionColor = (
  task: getTaskCompetitionColor_taskInterface,
  fallbackColor: HexColor
): HexColor => {
  if (
    !isTypes(task, [
      'CardsCountTargetTask',
      'CompleteCollectionsCountTargetTask',
    ])
  ) {
    return fallbackColor;
  }
  const matchingColor = task.competitions
    .map(({ slug }) => COMPETITION_COLORS[slug])
    .find(Boolean);
  return matchingColor ?? fallbackColor;
};

getTaskCompetitionColor.fragments = {
  taskInterface: gql`
    fragment getTaskCompetitionColor_taskInterface on TaskInterface {
      id
      ... on CardsCountTargetTask {
        id
        competitions {
          slug
        }
      }
      ... on CompleteCollectionsCountTargetTask {
        id
        competitions {
          slug
        }
      }
    }
  ` as TypedDocumentNode<getTaskCompetitionColor_taskInterface>,
};
